import { CalendarPlottedEvent } from '../../services/enterpriseCalendarsApi';
import { formatEventTimeLabel } from './calendarRecurrenceUtils';
import { getReadableTextColor } from './calendarUtils';

type CalendarEventChipProps = {
  event: CalendarPlottedEvent;
  onClick?: (event: CalendarPlottedEvent) => void;
  compact?: boolean;
};

export function CalendarEventChip({ event, onClick, compact = false }: CalendarEventChipProps) {
  const timeLabel = formatEventTimeLabel(event);

  return (
    <button
      type="button"
      className={`block w-full truncate rounded text-left font-medium ${
        compact ? 'px-1.5 py-0.5 text-[11px]' : 'px-2 py-1 text-xs'
      }`}
      style={{ backgroundColor: event.color, color: getReadableTextColor(event.color) }}
      title={`${event.name}${timeLabel ? ` (${timeLabel})` : ''} (${event.calendarName})`}
      onClick={(clickEvent) => {
        clickEvent.stopPropagation();
        onClick?.(event);
      }}
    >
      {timeLabel && !compact ? `${timeLabel} · ` : ''}
      {event.name}
    </button>
  );
}
